import _slicedToArray from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { createTracingClient } from "@azure/core-tracing";
import { SDK_VERSION } from "./constants";
import { accept1 } from "./generated/models/parameters";
import { toAnalyzeResultFromGenerated, toAnalyzedDocumentFromGenerated, toDocumentAnalysisPollOperationState } from "./lro/analyze";
import { lro } from "./lro/util/poller";
import { toGeneralDocumentResult } from "./models/GeneralDocumentResult";
import { toLayoutResult } from "./models/LayoutResult";
import { toReadResult } from "./models/ReadResult";
import { getMapper } from "./prebuilt/models";
import { Mappers, SERIALIZER, identity, makeServiceClient } from "./util";
/**
 * A client for interacting with the Form Recognizer service's analysis features.
 *
 * ### Examples:
 *
 * The Form Recognizer service and clients support two means of authentication:
 *
 * #### Azure Active Directory
 *
 * ```javascript
 * import { DocumentAnalysisClient } from "@azure/ai-form-recognizer";
 * import { DefaultAzureCredential } from "@azure/identity";
 *
 * const endpoint = "https://<resource name>.cognitiveservices.azure.com";
 * const credential = new DefaultAzureCredential();
 *
 * const client = new DocumentAnalysisClient(endpoint, credential);
 * ```
 *
 * #### API Key (Subscription Key)
 *
 * ```javascript
 * import { DocumentAnalysisClient, AzureKeyCredential } from "@azure/ai-form-recognizer";
 *
 * const endpoint = "https://<resource name>.cognitiveservices.azure.com";
 * const credential = new AzureKeyCredential("<api key>");
 *
 * const client = new DocumentAnalysisClient(endpoint, credential);
 * ```
 */

export var DocumentAnalysisClient = /*#__PURE__*/function () {
  function DocumentAnalysisClient(endpoint, credential) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, DocumentAnalysisClient);

    this._restClient = makeServiceClient(endpoint, credential, options);
    this._tracing = createTracingClient({
      packageName: "@azure/ai-form-recognizer",
      packageVersion: SDK_VERSION,
      namespace: "Microsoft.CognitiveServices"
    });
  }

  _createClass(DocumentAnalysisClient, [{
    key: "beginAnalyzeDocument",
    value: function () {
      var _beginAnalyzeDocument = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(model, input) {
        var _this = this;

        var options,
            _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                return _context.abrupt("return", this._tracing.withSpan("DocumentAnalysisClient.beginAnalyzeDocument", options, function (finalOptions) {
                  var initialModelId = typeof model === "string" ? model : model.modelId;
                  return _this.createAnalysisPoller(input, {
                    initialModelId: initialModelId,
                    options: finalOptions,
                    transformResult: function transformResult(result) {
                      return toAnalyzeResultFromGenerated(result, typeof model === "string" ? toAnalyzedDocumentFromGenerated : getMapper(model));
                    }
                  });
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function beginAnalyzeDocument(_x, _x2) {
        return _beginAnalyzeDocument.apply(this, arguments);
      }

      return beginAnalyzeDocument;
    }()
    /**
     * **Deprecation Warning**: This method is deprecated and will be replaced prior to a stable release of
     * `@azure/ai-form-recognizer` 4.0.0. Please see
     * [the deprecation notice](https://github.com/Azure/azure-sdk-for-js/blob/main/sdk/formrecognizer/ai-form-recognizer/README.md#beginextractlayout-deprecation)
     * in the README for more information.
     *
     * Extracts only the layout (basic OCR information) from an input file. The layout result includes information about
     * the pages and their text contents, extracted tables, and identified text styles.
     *
     * ### Examples
     *
     * This method supports both URLs (string) and streamable request bodies ({@link FormRecognizerRequestBody}) such as
     * Node.JS `ReadableStream` objects, browser `Blob`s, and `ArrayBuffer`s.
     *
     * #### From URL
     *
     * The Form Recognizer service will attempt to download a file using the submitted URL, so the URL must be accessible
     * from the public internet. For example, a SAS token can be used to grant read access to a blob in Azure Storage, and
     * the service will use the SAS-encoded URL to request the file.
     *
     * ```javascript
     * // the URL must be publicly accessible
     * const url = "<document url>";
     *
     * const poller = await client.beginExtractLayout(url);
     *
     * // The result is a long-running operation (poller), which must itself be polled until the operation completes
     * const {
     *   pages, // pages extracted from the document, which contain lines and words
     *   tables, // extracted tables, organized into cells that contain their contents
     *   styles // text styles (ex. handwriting) that were observed in the document
     * } = await poller.pollUntilDone();
     * ```
     *
     * #### From Request Body
     *
     * Alternatively, if the file is local (or in memory in the browser), a binary object can be uploaded. The following
     * example uses the Node.JS filesystem API.
     *
     * ```javascript
     * import * as fs from "fs";
     *
     * const file = fs.createReadStream("path/to/file.pdf");
     *
     * const poller = await client.beginExtractLayout(file);
     *
     * // The result is a long-running operation (poller), which must itself be polled until the operation completes
     * const {
     *   pages, // pages extracted from the document, which contain lines and words
     *   tables, // extracted tables, organized into cells that contain their contents
     *   styles // text styles (ex. handwriting) that were observed in the document
     * } = await poller.pollUntilDone();
     * ```
     *
     * @param input - a URL (string) to an input document accessible from the public internet, or a
     *                {@link FormRecognizerRequestBody} that will be uploaded with the request
     * @param options - optional settings for the analysis operation and poller
     * @returns a long-running operation (poller) that will eventually produce a layout result or an error
     * @deprecated will be replaced in a future version (prior to a stable release)
     */

  }, {
    key: "beginExtractLayout",
    value: function () {
      var _beginExtractLayout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(input) {
        var _this2 = this;

        var options,
            _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                return _context2.abrupt("return", this._tracing.withSpan("DocumentAnalysisClient.beginExtractLayout", options, function (finalOptions) {
                  return _this2.createAnalysisPoller(input, {
                    initialModelId: "prebuilt-layout",
                    options: finalOptions,
                    transformResult: function transformResult(res) {
                      return toLayoutResult(toAnalyzeResultFromGenerated(res, identity));
                    }
                  });
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function beginExtractLayout(_x3) {
        return _beginExtractLayout.apply(this, arguments);
      }

      return beginExtractLayout;
    }()
    /**
     * **Deprecation Warning**: This method is deprecated and will be replaced prior to a stable release of
     * `@azure/ai-form-recognizer` 4.0.0. Please see
     * [the deprecation notice](https://github.com/Azure/azure-sdk-for-js/blob/main/sdk/formrecognizer/ai-form-recognizer/README.md#beginextractgeneraldocument-deprecation)
     * in the README for more information.
     *
     * Extracts general document information from an input file. The general document result includes the information from
     * layout analysis (pages, tables, and styles) as well as extracted key-value pairs and entities.
     *
     * ### Examples
     *
     * This method supports both URLs (string) and streamable request bodies ({@link FormRecognizerRequestBody}) such as
     * Node.JS `ReadableStream` objects, browser `Blob`s, and `ArrayBuffer`s.
     *
     * #### From URL
     *
     * The Form Recognizer service will attempt to download a file using the submitted URL, so the URL must be accessible
     * from the public internet. For example, a SAS token can be used to grant read access to a blob in Azure Storage, and
     * the service will use the SAS-encoded URL to request the file.
     *
     * ```javascript
     * // the URL must be publicly accessible
     * const url = "<document url>";
     *
     * const poller = await client.beginExtractGeneralDocument(url);
     *
     * // The result is a long-running operation (poller), which must itself be polled until the operation completes
     * const {
     *   // the operation produces the fields from the layout operation
     *   pages, // pages extracted from the document, which contain lines and words
     *   tables, // extracted tables, organized into cells that contain their contents
     *   styles, // text styles (ex. handwriting) that were observed in the document
     *
     *   // it also produces the following fields in addition
     *   keyValuePairs, // extracted pairs of elements  (directed associations from one element in the input to another)
     *   entities // extracted entities in the input's content, which are categorized (ex. "Location" or "Organization")
     * } = await poller.pollUntilDone();
     * ```
     *
     * #### From Request Body
     *
     * Alternatively, if the file is local (or in memory in the browser), a binary object can be uploaded. The following
     * example uses the Node.JS filesystem API.
     *
     * ```javascript
     * import * as fs from "fs";
     *
     * const file = fs.createReadStream("path/to/file.pdf");
     *
     * const poller = await client.beginExtractGeneralDocument(file);
     *
     * // The result is a long-running operation (poller), which must itself be polled until the operation completes
     * const {
     *   // the operation produces the fields from the layout operation
     *   pages, // pages extracted from the document, which contain lines and words
     *   tables, // extracted tables, organized into cells that contain their contents
     *   styles, // text styles (ex. handwriting) that were observed in the document
     *
     *   // it also produces the following fields in addition
     *   keyValuePairs, // extracted pairs of elements  (directed associations from one element in the input to another)
     *   entities // extracted entities in the input's content, which are categorized (ex. "Location" or "Organization")
     * } = await poller.pollUntilDone();
     * ```
     *
     * @param input - a URL (string) to an input document accessible from the public internet, or a
     *                {@link FormRecognizerRequestBody} that will be uploaded with the request
     * @param options - optional settings for the analysis operation and poller
     * @returns a long-running operation (poller) that will eventually produce a general document result or an error
     * @deprecated will be replaced in a future version (prior to a stable release)
     */

  }, {
    key: "beginExtractGeneralDocument",
    value: function () {
      var _beginExtractGeneralDocument = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(input) {
        var _this3 = this;

        var options,
            _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                return _context3.abrupt("return", this._tracing.withSpan("DocumentAnalysisClient.beginExtractGeneralDocument", options, function (finalOptions) {
                  return _this3.createAnalysisPoller(input, {
                    initialModelId: "prebuilt-document",
                    options: finalOptions,
                    transformResult: function transformResult(res) {
                      return toGeneralDocumentResult(toAnalyzeResultFromGenerated(res, identity));
                    }
                  });
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function beginExtractGeneralDocument(_x4) {
        return _beginExtractGeneralDocument.apply(this, arguments);
      }

      return beginExtractGeneralDocument;
    }()
    /**
     * **Deprecation Warning**: This method is deprecated and will be replaced prior to a stable release of
     * `@azure/ai-form-recognizer` 4.0.0. Please see
     * [the deprecation notice](https://github.com/Azure/azure-sdk-for-js/blob/main/sdk/formrecognizer/ai-form-recognizer/README.md#beginreaddocument-deprecation)
     * in the README for more information.
     *
     * Extracts textual information from a document such as the text contents of pages and identified written languages.
     *
     * ### Examples
     *
     * This method supports both URLs (string) and streamable request bodies ({@link FormRecognizerRequestBody}) such as
     * Node.JS `ReadableStream` objects, browser `Blob`s, and `ArrayBuffer`s.
     *
     * #### From URL
     *
     * The Form Recognizer service will attempt to download a file using the submitted URL, so the URL must be accessible
     * from the public internet. For example, a SAS token can be used to grant read access to a blob in Azure Storage, and
     * the service will use the SAS-encoded URL to request the file.
     *
     * ```javascript
     * // the URL must be publicly accessible
     * const url = "<document url>";
     *
     * const poller = await client.beginReadDocument(url);
     *
     * // The result is a long-running operation (poller), which must itself be polled until the operation completes
     * const {
     *   // This operation only produces `pages` and `languages`
     *   pages, // pages extracted from the document, which contain lines and words
     *   languages, // extracted spans identifying the written language of text in the document
     * } = await poller.pollUntilDone();
     * ```
     *
     * #### From Request Body
     *
     * Alternatively, if the file is local (or in memory in the browser), a binary object can be uploaded. The following
     * example uses the Node.JS filesystem API.
     *
     * ```javascript
     * import * as fs from "fs";
     *
     * const file = fs.createReadStream("path/to/file.pdf");
     *
     * const poller = await client.beginReadDocument(file);
     *
     * // The result is a long-running operation (poller), which must itself be polled until the operation completes
     * const {
     *   // This operation only produces `pages` and `languages`
     *   pages, // pages extracted from the document, which contain lines and words
     *   languages, // extracted spans identifying the written language of text in the document
     * } = await poller.pollUntilDone();
     * ```
     *
     * @param input - a URL (string) to an input document accessible from the public internet, or a
     *                {@link FormRecognizerRequestBody} that will be uploaded with the request
     * @param options - optional settings for the analysis operation and poller
     * @returns a long-running operation (poller) that will eventually produce a read result or an error
     * @deprecated will be replaced in a future version (prior to a stable release)
     */

  }, {
    key: "beginReadDocument",
    value: function () {
      var _beginReadDocument = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(input) {
        var _this4 = this;

        var options,
            _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
                return _context4.abrupt("return", this._tracing.withSpan("DocumentAnalysisClient.beginReadDocument", options, function (finalOptions) {
                  return _this4.createAnalysisPoller(input, {
                    initialModelId: "prebuilt-read",
                    options: finalOptions,
                    transformResult: function transformResult(res) {
                      return toReadResult(toAnalyzeResultFromGenerated(res, identity));
                    }
                  });
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function beginReadDocument(_x5) {
        return _beginReadDocument.apply(this, arguments);
      }

      return beginReadDocument;
    }()
    /**
     * Create an LRO poller that handles analysis operations.
     *
     * This is the meat of all analysis polling operations.
     *
     * @param input - either a string for URL inputs or a FormRecognizerRequestBody to upload a file directly to the Form
     *                Recognizer API
     * @param definition - operation definition (initial model ID, operation transforms, request options)
     * @returns - an analysis poller that produces the given return types according to the operation spec
     */

  }, {
    key: "createAnalysisPoller",
    value: function () {
      var _createAnalysisPoller = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(input, definition) {
        var _this5 = this;

        var resumeFrom, getAnalyzeResult, toInit, poller;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                resumeFrom = definition.options.resumeFrom; // TODO: what should we do if resumeFrom.modelId is different from initialModelId?
                // And what do we do with the redundant input??

                getAnalyzeResult = function getAnalyzeResult(operationLocation) {
                  return _this5._tracing.withSpan("DocumentAnalysisClient.createAnalysisPoller-getAnalyzeResult", definition.options, function (finalOptions) {
                    return _this5._restClient.sendOperationRequest({
                      options: finalOptions
                    }, {
                      path: operationLocation,
                      httpMethod: "GET",
                      responses: {
                        200: {
                          bodyMapper: Mappers.AnalyzeResultOperation
                        },
                        default: {
                          bodyMapper: Mappers.ErrorResponse
                        }
                      },
                      // URL is fully-formed, so we don't need any query parameters
                      headerParameters: [accept1],
                      serializer: SERIALIZER
                    });
                  });
                };

                toInit = // If the user gave us a stored token, we'll poll it again
                resumeFrom !== undefined ? /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          return _context6.abrupt("return", _this5._tracing.withSpan("DocumentAnalysisClient.createAnalysisPoller-resume", definition.options, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                            var _JSON$parse, operationLocation, modelId, result;

                            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                              while (1) {
                                switch (_context5.prev = _context5.next) {
                                  case 0:
                                    _JSON$parse = JSON.parse(resumeFrom), operationLocation = _JSON$parse.operationLocation, modelId = _JSON$parse.modelId;
                                    _context5.next = 3;
                                    return getAnalyzeResult(operationLocation);

                                  case 3:
                                    result = _context5.sent;
                                    return _context5.abrupt("return", toDocumentAnalysisPollOperationState(definition, modelId, operationLocation, result));

                                  case 5:
                                  case "end":
                                    return _context5.stop();
                                }
                              }
                            }, _callee5);
                          }))));

                        case 1:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                })) :
                /*#__PURE__*/
                // Otherwise, we'll start a new operation from the initialModelId
                _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          return _context8.abrupt("return", _this5._tracing.withSpan("DocumentAnalysisClient.createAnalysisPoller-start", definition.options, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                            var _toAnalyzeRequest, _toAnalyzeRequest2, contentType, analyzeRequest, _yield$_this5$_restCl, operationLocation, result;

                            return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                              while (1) {
                                switch (_context7.prev = _context7.next) {
                                  case 0:
                                    _toAnalyzeRequest = toAnalyzeRequest(input), _toAnalyzeRequest2 = _slicedToArray(_toAnalyzeRequest, 2), contentType = _toAnalyzeRequest2[0], analyzeRequest = _toAnalyzeRequest2[1];
                                    _context7.next = 3;
                                    return _this5._restClient.analyzeDocument(definition.initialModelId, contentType, Object.assign(Object.assign({}, definition.options), {
                                      analyzeRequest: analyzeRequest
                                    }));

                                  case 3:
                                    _yield$_this5$_restCl = _context7.sent;
                                    operationLocation = _yield$_this5$_restCl.operationLocation;

                                    if (!(operationLocation === undefined)) {
                                      _context7.next = 7;
                                      break;
                                    }

                                    throw new Error("Unable to start analysis operation: no Operation-Location received.");

                                  case 7:
                                    _context7.next = 9;
                                    return getAnalyzeResult(operationLocation);

                                  case 9:
                                    result = _context7.sent;
                                    return _context7.abrupt("return", toDocumentAnalysisPollOperationState(definition, definition.initialModelId, operationLocation, result));

                                  case 11:
                                  case "end":
                                    return _context7.stop();
                                }
                              }
                            }, _callee7);
                          }))));

                        case 1:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8);
                }));
                _context11.next = 5;
                return lro({
                  init: toInit,
                  poll: function () {
                    var _poll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(_ref5) {
                      var operationLocation, modelId;
                      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                        while (1) {
                          switch (_context10.prev = _context10.next) {
                            case 0:
                              operationLocation = _ref5.operationLocation, modelId = _ref5.modelId;
                              return _context10.abrupt("return", _this5._tracing.withSpan("DocumentAnalysisClient.createAnalysisPoller-poll", {}, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                                var result;
                                return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                                  while (1) {
                                    switch (_context9.prev = _context9.next) {
                                      case 0:
                                        _context9.next = 2;
                                        return getAnalyzeResult(operationLocation);

                                      case 2:
                                        result = _context9.sent;
                                        return _context9.abrupt("return", toDocumentAnalysisPollOperationState(definition, modelId, operationLocation, result));

                                      case 4:
                                      case "end":
                                        return _context9.stop();
                                    }
                                  }
                                }, _callee9);
                              }))));

                            case 2:
                            case "end":
                              return _context10.stop();
                          }
                        }
                      }, _callee10);
                    }));

                    function poll(_x8) {
                      return _poll.apply(this, arguments);
                    }

                    return poll;
                  }(),
                  serialize: function serialize(_ref7) {
                    var operationLocation = _ref7.operationLocation,
                        modelId = _ref7.modelId;
                    return JSON.stringify({
                      modelId: modelId,
                      operationLocation: operationLocation
                    });
                  }
                }, definition.options.updateIntervalInMs);

              case 5:
                poller = _context11.sent;

                if (definition.options.onProgress !== undefined) {
                  poller.onProgress(definition.options.onProgress);
                  definition.options.onProgress(poller.getOperationState());
                }

                return _context11.abrupt("return", poller);

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function createAnalysisPoller(_x6, _x7) {
        return _createAnalysisPoller.apply(this, arguments);
      }

      return createAnalysisPoller;
    }()
  }]);

  return DocumentAnalysisClient;
}();
/**
 * Produce an appropriate pair of content-type and analyzeRequest value for the analysis request.
 * @internal
 */

function toAnalyzeRequest(input) {
  if (typeof input === "string") {
    return ["application/json", {
      urlSource: input
    }];
  } else {
    return ["application/octet-stream", input];
  }
}